import React, { useState } from 'react';
import { useAuth } from '../App';
import ChequeManagement from './ChequeManagement';
import ChequesVencimientoDashboard from './ChequesVencimientoDashboard';
import UserManagement from './UserManagement';

function Dashboard() {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('cheques');
  const [editingCheque, setEditingCheque] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const isSuperAdmin = user?.role === 'ROLE_SUPER_ADMIN';

  const getRoleDisplay = (role) => {
    switch (role) {
      case 'ROLE_SUPER_ADMIN':
        return 'Super Administrador';
      case 'ROLE_USER':
        return 'Usuario';
      default:
        return role;
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setMenuOpen(false);
    setEditingCheque(null);
  };

  const handleEditCheque = (cheque) => {
    setEditingCheque(cheque);
    setActiveTab('cheques');
    setMenuOpen(false);
  };

  const getNavItems = () => {
    const items = [
      { id: 'cheques', label: 'Cheques' },
      { id: 'vencimientos', label: 'Vencimientos' }
    ];
    if (isSuperAdmin) {
      items.push({ id: 'users', label: 'Usuarios' });
    }
    return items;
  };

  const navItems = getNavItems();

  return (
    <div>
      <header className="header">
        <div className="header-left">
          <button
            className="hamburger-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <h1>Cheques</h1>
        </div>
        <div className="header-info">
          <span className="user-name">{user?.nombre}</span>
          <span className="role-badge">{getRoleDisplay(user?.role)}</span>
          <button onClick={logout} className="btn btn-logout">Cerrar Sesión</button>
        </div>
      </header>

      {/* Mobile dropdown menu */}
      <nav className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
        {navItems.map(item => (
          <button
            key={item.id}
            className={`mobile-nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => handleTabChange(item.id)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      {/* Desktop navigation tabs */}
      <nav className="dashboard-nav desktop-nav">
        {navItems.map(item => (
          <button
            key={item.id}
            className={`nav-tab ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => handleTabChange(item.id)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      <div className="dashboard-content">
        {activeTab === 'cheques' && (
          <div className="card">
            <ChequeManagement
              initialEditCheque={editingCheque}
              onEditHandled={() => setEditingCheque(null)}
            />
          </div>
        )}

        {activeTab === 'vencimientos' && (
          <div className="card">
            <h2 className="page-title">Vencimientos</h2>
            <ChequesVencimientoDashboard onEditCheque={handleEditCheque} />
          </div>
        )}

        {isSuperAdmin && activeTab === 'users' && (
          <div className="card">
            <UserManagement />
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
